import * as React from 'react'
import { TourManageModel, TourOverViewIconTypeOptions, TourOverviewModel, TourOverviewPointModel } from '../../models/TourManageModel'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'traveldesk-ui/dist/store'
import { Buttons, Col, FieldFooter, FormFieldWrapper, MediaSelector, nameof, Photo, Row, Select, SelectOptionModel, Tooltip } from 'traveldesk-ui'
interface Props {
    tourOverview?: TourOverviewModel
    onChange: (tourOverview: TourOverviewModel | undefined) => void
}
const TourFormOverview = (props: Props) => {
    const Localization = useSelector((state: ApplicationState) => state.localization.locale)
    const onChangeTitle = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!tourOverview) return
        props.onChange(Object.assign(TourOverviewModel.Create(tourOverview), { title: e.target.value }))
    }
    const onChangeDescription = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (!tourOverview) return
        props.onChange(Object.assign(TourOverviewModel.Create(tourOverview), { description: e.target.value }))
    }
    const onSelectHeroImage = (photo: Photo) => {
        if (!tourOverview) return
        props.onChange(Object.assign(TourOverviewModel.Create(tourOverview), {
            heroImageId: photo.id,
            heroImage: photo
        }))
    }
    const onClearHeroImage = () => {
        if (!tourOverview) return
        props.onChange(Object.assign(TourOverviewModel.Create(tourOverview), {
            heroImageId: undefined,
            heroImage: undefined
        }))
    }
    const onRemoveTourOverview = () => {
        props.onChange(undefined)
    }
    const onAddTourOverview = () => {
        props.onChange(new TourOverviewModel())
    }
    const onAddPoint = () => {
        if (!tourOverview) return
        props.onChange(Object.assign(TourOverviewModel.Create(tourOverview), {
            points: tourOverview.points.concat([new TourOverviewPointModel()])
        }))
    }
    const onChangePoint = (guid: string, fieldName: string, value: any) => {
        if (!tourOverview) return
        props.onChange(Object.assign(TourOverviewModel.Create(tourOverview), {
            points: tourOverview.points.map(x => x.guid == guid
                ? Object.assign(new TourOverviewPointModel(), x, { [fieldName]: value })
                : x
            )
        }))
    }
    const onDeletePoint = (guid: string) => {
        if (!tourOverview) return
        props.onChange(Object.assign(TourOverviewModel.Create(tourOverview), {
            points: tourOverview.points.filter(x => x.guid != guid)
        }))
    }
    const tourOverview = props.tourOverview
    return <FormFieldWrapper>
        <h3>Tour Overview</h3>
        {tourOverview
            ? <React.Fragment>
                <Row>
                    <Col type='50'>
                        <MediaSelector
                            selected={tourOverview.heroImage ? [tourOverview.heroImage] : []}
                            onSelectPhotos={(photos: Photo[]) => {
                                onSelectHeroImage(photos[0])
                            }}
                            onDelete={(photo: Photo) => {
                                onClearHeroImage()
                            }}
                        />
                    </Col>
                    <Col type='50'>
                        <label>Title</label>
                        <input type="text" value={tourOverview.title ?? ''} onChange={onChangeTitle} />
                        <label>Description</label>
                        <textarea rows={2} value={tourOverview.description ?? ''} onChange={onChangeDescription}></textarea>
                        <FieldFooter error={tourOverview.hasError} />
                    </Col>
                </Row>
                <h4>Key points</h4>
                {tourOverview.points.map(p => <React.Fragment>
                    <Row key={p.guid}>
                        <Col type='50'>
                            <label>Title</label>
                            <input type="text" value={p.title ?? ''} onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangePoint(p.guid, 'title', e.target.value)} />
                            <label>Icon type</label>
                            <Select
                                options={TourOverViewIconTypeOptions}
                                value={p.iconType}
                                onChange={(option: SelectOptionModel) => {
                                    onChangePoint(p.guid, 'iconType', option.value)
                                }}
                            />
                        </Col>
                        <Col type="50">
                            <label>Description</label>
                            <textarea rows={3} value={p.description} onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onChangePoint(p.guid, 'description', e.target.value)}></textarea>
                            <FieldFooter error={p.hasError} />
                        </Col>
                        <i className='fa fa-trash floar-right clickable' onClick={() => onDeletePoint(p.guid)} />

                    </Row>
                    <hr />
                </React.Fragment>)}
                <Tooltip text={Localization.getString('Add keypoint')}>
                    <Buttons.ButtonSmallGreen onClick={onAddPoint}>
                        <i className="fa fa-plus" />
                    </Buttons.ButtonSmallGreen>
                </Tooltip>
            </React.Fragment>
            : <Tooltip text={Localization.getString('Add tour overview')}>
                <Buttons.ButtonSmallGreen onClick={onAddTourOverview}>
                    <i className="fa fa-plus" />
                </Buttons.ButtonSmallGreen>
            </Tooltip>
        }
    </FormFieldWrapper>
}
export default TourFormOverview